import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import vndrAprvlService from "../Services/Service";

import { IconButton } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import RegistrationForm from "./Registration/RegistartionForm";

import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";

const VendorApprovalStatus = () => {
  const [rows, setRows] = useState([]);
  const [approvalRows, setApprovalRows] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const [open, setOpen] = useState(false);

  const [openRegistration, setOpenRegistration] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(0);

  useEffect(() => {
    fetchVendorStatus();
  }, []);

  const fetchVendorStatus = async () => {
    try {
      vndrAprvlService.setApiUrl(
        sessionStorage.getItem("APIUrl") + "/api/VndrAprvl",
      );

      const res = await vndrAprvlService.getVendorApprovalStatus();

      const data = res.data.map((item) => ({
        id: item.vendorID,
        vendorName: item.vendorName,
        status: item.aprvrStat, // returned from repository
      }));

      setRows(data);
    } catch (err) {
      console.log(err);
    }
  };
  // const handleView = async (row) => {

  //   try {
  //     vndrAprvlService.setApiUrl(
  //       sessionStorage.getItem("APIUrl") + "/api/VndrAprvl"
  //     );

  //     const res = await vndrAprvlService.getApprovalHistory(row.id);

  //     setApprovalRows(res.data);
  //     setVendorName(row.vendorName);

  //     setOpen(true);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const handleView = async (row) => {
    setSelectedVendorId(row.id);

    try {
      vndrAprvlService.setApiUrl(
        sessionStorage.getItem("APIUrl") + "/api/VndrAprvl",
      );

      const res = await vndrAprvlService.getApprovalHistory(row.id);

      setApprovalRows(res.data);
      setVendorName(row.vendorName);

      setOpen(true);
    } catch (err) {
      console.log(err);
    }
  };

  const handleRegistrationView = () => {
    setOpenRegistration(true);
  };

  const getStatusChip = (status) => {
    const value = (status || "").toLowerCase();

    switch (value) {
      case "approved":
        return (
          <Chip
            label="Completed"
            size="small"
            sx={{
              bgcolor: "#EDF7ED",
              color: "#2E7D32",
              fontWeight: 550,
              fontSize: "0.93rem",
              height: 27,
              borderRadius: "20px",
              px: 1,
              "& .MuiChip-label": {
                px: 0.5,
              },
            }}
          />
        );

      case "pending":
        return (
          <Chip
            label="Pending"
            size="small"
            sx={{
              bgcolor: "#FFF7E6",
              color: "#F59E0B",
              fontWeight: 550,
              fontSize: "0.93rem",
              height: 27,
              borderRadius: "20px",
              px: 1,
              "& .MuiChip-label": {
                px: 0.5,
              },
            }}
          />
        );

      case "rejected":
        return (
          <Chip
            label="Rejected"
            size="small"
            sx={{
              bgcolor: "#FDECEC",
              color: "#EF4444",
              fontWeight: 550,
              fontSize: "0.93rem",
              height: 27,
              borderRadius: "20px",
              px: 1,
              "& .MuiChip-label": {
                px: 0.5,
              },
            }}
          />
        );

      default:
        return <Chip label={status} size="small" variant="outlined" />;
    }
  };

  //   const columns = [
  //     {
  //       field: "id",
  //       headerName: "Vendor ID",
  //       width: 150,
  //     },
  //     {
  //       field: "vendorName",
  //       headerName: "Vendor Name",
  //       flex: 1,
  //     },
  //     {
  //       field: "action",
  //       headerName: "View",
  //       width: 150,
  //       sortable: false,
  //       renderCell: (params) => (
  //         <Button
  //           variant="contained"
  //           size="small"
  //           onClick={() => handleView(params.row)}
  //         >
  //           View
  //         </Button>
  //       ),
  //     },
  //   ];

  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: "id",
      headerName: "Vendor ID",
      width: 150,
    },
    {
      field: "vendorName",
      headerName: "Vendor Name",
      flex: 1,
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 160,
    // },

    {
      field: "status",
      headerName: "Status",
      width: 180,

      renderCell: (params) => getStatusChip(params.value),
    },
    {
      field: "action",
      headerName: "View",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleView(params.row)}
        >
          View
        </Button>
      ),
    },
  ];
  const historyColumns = [
    {
      field: "email",
      headerName: "Mail ID",
      flex: 1,
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 150,
    // },

    {
      field: "status",
      headerName: "Status",
      width: 180,

      renderCell: (params) => getStatusChip(params.value),
    },
    {
      field: "remark",
      headerName: "Remark",
      flex: 1,
    },
  ];

  //  ADD THIS HERE
  if (openRegistration) {
    return (
      <Box sx={{ p: 3 }}>
        <Button
          variant="contained"
          onClick={() => setOpenRegistration(false)}
          startIcon={<ArrowCircleLeftIcon />}
          sx={{
            mb: 2,
            px: 3,
            py: 1,
            fontSize: "0.95rem",
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
          }}
        >
          Back to Vendor Approval Status
        </Button>

        <RegistrationForm vendorId={selectedVendorId} mode="view" />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Vendor Approval Status
      </Typography>

      <DataGrid
        rows={rows}
        columns={columns}
        columnVisibilityModel={{
          id: false,
        }}
        autoHeight
        pageSize={10}
      />

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        {/* <DialogTitle>
          Approval History - {vendorName}
        </DialogTitle> */}

        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Approval History - {vendorName}</Typography>

          <IconButton color="primary" onClick={handleRegistrationView}>
            <Visibility />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DataGrid
            autoHeight
            hideFooter
            rows={approvalRows.map((item, index) => ({
              id: index + 1,
              email: item.mailID,
              status: item.aprvrStat,
              remark: item.aprvlRem || "-",
            }))}
            columns={historyColumns}
          />
        </DialogContent>
      </Dialog>

      {/* <Dialog
        open={openRegistration}
        onClose={() => setOpenRegistration(false)}
        fullScreen
      >
       

        <RegistrationForm
          vendorId={selectedVendorId}
          mode="view"
          onBack={() => setOpenRegistration(false)}
          backButtonText="Back to Vendor Approval Status"
        />
      </Dialog> */}
    </Box>
  );
};

export default VendorApprovalStatus;
